<template>
  <el-dialog
    :close-on-click-modal="false"
    title="主卡充值申请"
    :lock-scroll="true"
    :visible.sync="dialogFormVisible"
    width="410px"
  >
    <section v-loading="getDetailLoading">
      <div class="recharge-remark">
        <p class="title">操作流程说明：</p>
        <ol class="content">
          <li>1、流程：主卡充值申请--->核销{{ this.$route.path.includes('gasCard') ?'（气卡充值记录）':'（油卡充值记录）'}}。</li>
          <li>2、付款是打款到{{ this.$route.path.includes('gasCard') ?'气卡':'油卡'}}服务商指定的的账户，可线下支付。</li>
          <li>3、主卡账户上充值金额到账后再进行核销。</li>
        </ol>
      </div>
      <qx-custom-form @sub="sub" :noSubBtn="true" ref="customForm" :formData="formData" />
    </section>
    <section slot="footer" class="dialog-footer">
      <el-button @click="dialogFormVisible = false">取 消</el-button>
      <el-button
        type="primary"
        @click="customFormPost"
        :loading="subLoading || getDetailLoading"
      >确 定</el-button>
    </section>
  </el-dialog>
</template>

<script>
// import {
//   levelAllList,
// } from 'api/customer/level';
// import {
//   customerSetLevel,
// } from 'api/customer/customer';
import {
  doOilCardRecharge,
  toParentRecharge,
} from 'api/service';
export default {
  data () {
    return {
      getDetailLoading: false, // 获取详情loading
      dialogFormVisible: false,
      subLoading: false, // 提交loading
      type: '', // add/新增 edit/修改
      merLoading: false, // 商户选项loading中
      originData: {},
      formData: {
        form: [
          {
            label: '油卡卡ID',
            value: 'cardId',
            type: 'input',
            hide: true,
            readonly: true,
          },
          {
            label: '主卡类型',
            value: 'oilCardTypeName',
            type: 'input',
            placeholder: '请输入主卡类型',
            readonly: true,
          },
          {
            label: '主卡卡号',
            value: 'oilCarNum',
            type: 'input',
            placeholder: '请输入主卡卡号',
            readonly: true,
          },
          {
            label: '主卡余额',
            value: 'cardBalanceStr',
            type: 'input',
            unit: '元',
            placeholder: '请输入主卡余额',
            readonly: true,
          },
          {
            label: '充值金额',
            value: 'preOilFee',
            type: 'input',
            unit: '元',
            placeholder: '请输入充值金额',
          },
          {
            label: '服务商',
            value: 'companyName',
            type: 'input',
            placeholder: '请输入服务商',
            readonly: true,
          },
          {
            label: '收款账户',
            value: 'acctName',
            type: 'input',
            placeholder: '请输入收款账户',
            // readonly: true,
          },
          {
            label: '收款账号',
            value: 'acctNo',
            type: 'input',
            placeholder: '请输入收款账号',
            // readonly: true,
          },
          {
            label: '开户银行',
            value: 'branchName',
            type: 'input',
            placeholder: '请输入开户银行',
            // readonly: true,
          },
        ],
        rules: { // 表单验证规则
          preOilFee: [ // 充值金额
            { required: true, message: '请输入充值金额', trigger: 'blur' },
          ],
        },
      },
    };
  },
  methods: {

    /**
     * @param {Object} item 修改的项
     * @returns {void}
     * @description 打开弹窗并初始化数据
     */
    show (item) {
      this.dialogFormVisible = true; // 打开弹窗
      this.$refs.customForm && this.$refs.customForm.reset();
      this.originData = item;
      this.getRechargeInfo(item);
    },

    customFormPost () {
      this.$refs.customForm.sub();
    },

    async getRechargeInfo (item) {
      const res = await toParentRecharge({
        cardId: item.cardId,
      });
      if (!res.failed) {
        const data = {
          oilCardTypeName: res.oilCardParentOut.oilCardTypeName || '',
          oilCarNum: res.oilCardParentOut.oilCarNum || '',
          cardBalanceStr: res.oilCardParentOut.cardBalanceStr || '',
          companyName: res.oilCardParentOut.companyName || '',
          acctName: res.accountBankRel.acctName || '',
          acctNo: res.accountBankRel.acctNo || '',
          branchName: res.accountBankRel.branchName || '',
          preOilFee: '',
        };
        this.$nextTick(() => {
          this.$refs.customForm && this.$refs.customForm.setVal(data);
        });
      }
    },

    /**
     * @param {Object} form 表单数据
     * @returns {void}
     * @description 弹窗确定按钮事件
     */
    async sub (form) {
      form.preOilFee = form.preOilFee * 100;
      if (this.originData.cardId) {
        this.subLoading = true;
        const res = await doOilCardRecharge({
          cardId: this.originData.cardId,
          preOilFee: form.preOilFee,
          cardCategory: this.$route.path.includes('gasCard') ? 2 : 1,
        });
        this.subLoading = false;
        if (!res.failed) {
          this.dialogFormVisible = false; // 关闭弹窗
          this.$message({
            type: 'success',
            message: '充值成功',
          });
          this.$emit('sub');
        }
      } else {
        this.$message({
          type: 'warning',
          message: '缺少卡信息',
        });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.recharge-remark {
  color: #999999;
  margin-top: -20px;
  margin-bottom: 10px;
  .title {
  }
  .content {
    line-height: 1.6;
    padding: 5px 0;
  }
}
</style>
